import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import LoadingSpinner from "./LoadingSpinner";

const ProtectedRoute = ({
  children,
  requireAgent = false,
  requireAdmin = false,
}) => {
  const { user, loading, isAgent, isAdmin } = useAuth();

  // 🔍 Add these logs here
  // console.log("ProtectedRoute: user", user);
  // console.log("isAdmin:", isAdmin, "requireAdmin:", requireAdmin);
  // console.log("isAgent:", isAgent, "requireAgent:", requireAgent);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (requireAgent && !isAgent) {
    return <Navigate to="/" />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
